<template>

    <div class="donors knowledge-base">
        <knowledge-nav />

        <div class="donors__heading knowledge-base__heading">

            <svg width="684" height="104" viewBox="0 0 684 104" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M0 118.396V1.60428H37.5639C47.8693 1.60428 57.1335 3.95722 65.3564 8.6631C73.5794 13.3155 79.9869 19.9198 84.5789 28.4759C89.2244 36.9786 91.5738 46.5241 91.6272 57.1123V62.4866C91.6272 73.1818 89.3578 82.7808 84.8192 91.2834C80.334 99.7326 73.9799 106.364 65.7569 111.176C57.5874 115.936 48.4567 118.342 38.3649 118.396H0ZM28.1129 23.3422V96.738H37.8843C45.9471 96.738 52.141 93.877 56.466 88.1551C60.7911 82.3797 62.9536 73.8235 62.9536 62.4866V57.4332C62.9536 46.1497 60.7911 37.6471 56.466 31.9251C52.141 26.2032 45.8403 23.3422 37.5639 23.3422H28.1129Z" fill="#F0F5FD" fill-opacity="0.1"/>
                <path d="M213.001 62.4064C213.001 73.7968 210.892 83.877 206.674 92.6471C202.455 101.417 196.448 108.182 188.653 112.941C180.91 117.647 172.073 120 162.142 120C152.21 120 143.4 117.727 135.711 113.182C128.022 108.583 122.015 102.032 117.69 93.5294C113.418 85.0267 111.175 75.2674 110.962 64.2513V57.6738C110.962 46.2299 113.044 36.1497 117.209 27.4332C121.427 18.6631 127.434 11.8984 135.23 7.13904C143.079 2.37968 151.996 0 161.981 0C171.86 0 180.67 2.35294 188.412 7.05882C196.155 11.7647 202.162 18.4759 206.433 27.1925C210.758 35.8556 212.948 45.8021 213.001 57.0321V62.4064ZM184.408 57.5134C184.408 45.9091 182.459 37.1123 178.561 31.123C174.716 25.0802 169.19 22.0588 161.981 22.0588C147.885 22.0588 140.436 32.6471 139.635 53.8235L139.555 62.4064C139.555 73.8503 141.451 82.6471 145.242 88.7968C149.033 94.9465 154.666 98.0214 162.142 98.0214C169.243 98.0214 174.716 95 178.561 88.9572C182.405 82.9144 184.354 74.2246 184.408 62.8877V57.5134Z" fill="#F0F5FD" fill-opacity="0.1"/>
                <path d="M333.094 118.396H305.141L263.813 45.7219V118.396H235.7V1.60428H263.813L305.061 74.2781V1.60428H333.094V118.396Z" fill="#F0F5FD" fill-opacity="0.1"/>
                <path d="M457.831 62.4064C457.831 73.7968 455.722 83.877 451.504 92.6471C447.286 101.417 441.279 108.182 433.483 112.941C425.741 117.647 416.904 120 406.972 120C397.04 120 388.23 117.727 380.541 113.182C372.852 108.583 366.845 102.032 362.52 93.5294C358.248 85.0267 356.006 75.2674 355.792 64.2513V57.6738C355.792 46.2299 357.875 36.1497 362.039 27.4332C366.258 18.6631 372.265 11.8984 380.061 7.13904C387.91 2.37968 396.827 0 406.812 0C416.69 0 425.5 2.35294 433.243 7.05882C440.985 11.7647 446.992 18.4759 451.264 27.1925C455.589 35.8556 457.778 45.8021 457.831 57.0321V62.4064ZM429.238 57.5134C429.238 45.9091 427.289 37.1123 423.391 31.123C419.547 25.0802 414.02 22.0588 406.812 22.0588C392.715 22.0588 385.267 32.6471 384.466 53.8235L384.386 62.4064C384.386 73.8503 386.281 82.6471 390.072 88.7968C393.863 94.9465 399.497 98.0214 406.972 98.0214C414.074 98.0214 419.547 95 423.391 88.9572C427.236 82.9144 429.185 74.2246 429.238 62.8877V57.5134Z" fill="#F0F5FD" fill-opacity="0.1"/>
                <path d="M523.861 77.1658H508.643V118.396H480.53V1.60428H526.424C540.253 1.60428 551.066 4.67914 558.862 10.8289C566.657 16.9786 570.555 25.6685 570.555 36.8984C570.555 45.0267 568.9 51.7647 565.589 57.1123C562.332 62.4599 557.206 66.7915 550.211 70.107L574.56 117.193V118.396H544.445L523.861 77.1658ZM508.643 55.4278H526.424C531.763 55.4278 535.768 54.0374 538.438 51.2567C541.161 48.4225 542.523 44.492 542.523 39.4652C542.523 34.4385 541.161 30.508 538.438 27.6738C535.715 24.7861 531.71 23.3422 526.424 23.3422H508.643V55.4278Z" fill="#F0F5FD" fill-opacity="0.1"/>
                <path d="M655.887 87.3529C655.887 83.2353 654.419 80.0267 651.482 77.7273C648.599 75.4278 643.499 73.0481 636.184 70.5882C628.869 68.1283 622.888 65.7487 618.243 63.4492C603.132 56.016 595.577 45.8021 595.577 32.8075C595.577 26.3369 597.445 20.6417 601.183 15.7219C604.974 10.7487 610.314 6.8984 617.202 4.17112C624.09 1.39037 631.832 0 640.429 0C648.812 0 656.314 1.49733 662.935 4.49198C669.61 7.48663 674.789 11.7647 678.474 17.3262C682.158 22.8342 684 29.1444 684 36.2567H655.967C655.967 31.4973 654.499 27.8075 651.562 25.1872C648.679 22.5668 644.754 21.2567 639.788 21.2567C634.769 21.2567 630.791 22.3797 627.854 24.6257C624.971 26.8182 623.529 29.6257 623.529 33.0481C623.529 36.0428 625.131 38.7701 628.335 41.2299C631.539 43.6364 637.172 46.1497 645.235 48.7701C653.297 51.3369 659.919 54.1176 665.098 57.1123C677.699 64.385 684 74.4118 684 87.1925C684 97.4064 680.156 105.428 672.466 111.257C664.778 117.086 654.232 120 640.829 120C631.378 120 622.808 118.316 615.119 114.947C607.484 111.524 601.717 106.872 597.819 100.989C593.975 95.0535 592.052 88.2353 592.052 80.5348H620.245C620.245 86.7915 621.847 91.4171 625.051 94.4118C628.308 97.3529 633.568 98.8235 640.829 98.8235C645.475 98.8235 649.133 97.8342 651.802 95.8556C654.526 93.8235 655.887 90.9893 655.887 87.3529Z" fill="#F0F5FD" fill-opacity="0.1"/>
            </svg>

            <div class="donors__heading-title knowledge-base__heading-title">
                {{$store.getters.t('donors_donors')}}
            </div>

        </div>

        <div class="donors__grid">
            <div class="container">
                <div class="row">
                    <div class="col-md-12 col-lg-3">
                        <!-- start aside -->
                        <aside class="sidebar product--sidebar" @click="filterToggle">

                            <!-- end /.sidebar-card -->
                            <div class="product--sidebar-wrapper">
                                <div class="sidebar-card card--filter">
                                    <a class="card-title" href="#collapse1" role="button" data-toggle="collapse" aria-expanded="false" aria-controls="collapse1">
                                        <h4>{{$store.getters.t('donors_weight')}}
                                            <span class="lnr lnr-chevron-down"></span>
                                        </h4>
                                    </a>
                                    <div class="collapse show collapsible-content" id="collapse1">
                                        <ul class="card-content">
                                            <li v-for="(weight, key) in weightCategories" :key="key">
                                                <div class="custom-checkbox2">
                                                    <input type="checkbox" @change="change(key ,$event)"
                                                           :checked="selectedWeight === key" :id="`weight_${key}`" :value="key" class="">
                                                    <label :for="`weight_${key}`">
                                                        <span class="square"></span>{{weight}}
                                                    </label>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <!-- end /.sidebar-card -->

                                <div class="sidebar-card card--filter">
                                    <a class="card-title" href="#collapse2" role="button" data-toggle="collapse" aria-expanded="false" aria-controls="collapse2">
                                        <h4>{{$store.getters.t('donors_categories')}}
                                            <span class="lnr lnr-chevron-down"></span>
                                        </h4>
                                    </a>
                                    <div class="collapse show collapsible-content" id="collapse2">
                                        <ul class="card-content">
                                            <li v-for="(category, key) in petsCategories" :key="key">
                                                <div class="custom-checkbox2">
                                                    <input type="checkbox" v-model="selectedCategories" :id="`category_${category.code}`" :value="category.id"  class="">
                                                    <label :for="`category_${category.code}`">
                                                        <span class="square"></span>{{category.name}}
                                                    </label>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <!-- end /.sidebar-card -->

                                <div class="sidebar-card card--slider">
                                    <a class="card-title" href="#collapse3" role="button" data-toggle="collapse" aria-expanded="false" aria-controls="collapse3">
                                        <h4>{{$store.getters.t('donors_city')}}
                                            <span class="lnr lnr-chevron-down"></span>
                                        </h4>
                                    </a>
                                    <div class="collapse show collapsible-content" id="collapse3">
                                        <div class="card-content">
                                            <div class="form-group mt-2">
                                                <label for="city_id">{{$store.getters.t('donors_locality')}}</label>
                                                <div class="" style="position:relative;">
                                                    <input v-model="citySearch" class="form-control city-filter" autocomplete="off" id="city_id" :placeholder="$store.getters.t('donors_start_typing_locality')"/>
                                                    <div class="search-result" v-if="cities.length">
                                                        <div class="city-item" v-for="city in cities" @click="setCityId(city.id, city.name)">{{city.name}}</div>
                                                    </div>
                                                    <div class="search-result" v-if="!cities.length && citySearch && citySearch !== citySelected">
                                                        <div class="city-item">{{$store.getters.t('donors_nothing_found')}}</div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                            <button id="sidebar-toggle" @click.prevent="sidebarFilterToggle">

                                <svg width="23" height="15" viewBox="0 0 23 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M0 0.882353C0 0.395037 0.466882 0 1.04278 0H21.8984C22.4743 0 22.9412 0.395037 22.9412 0.882353C22.9412 1.36967 22.4743 1.76471 21.8984 1.76471H1.04278C0.466882 1.76471 0 1.36967 0 0.882353Z" fill="white"/>
                                    <path d="M7.05884 9.7059C7.05884 9.21859 7.36273 8.82355 7.73757 8.82355H15.2036C15.5785 8.82355 15.8824 9.21859 15.8824 9.7059C15.8824 10.1932 15.5785 10.5883 15.2036 10.5883H7.73757C7.36273 10.5883 7.05884 10.1932 7.05884 9.7059Z" fill="white"/>
                                    <path d="M4.41187 5.2941C4.41187 4.80679 4.89809 4.41174 5.49784 4.41174H17.4435C18.0433 4.41174 18.5295 4.80679 18.5295 5.2941C18.5295 5.7814 18.0433 6.17645 17.4435 6.17645H5.49784C4.89809 6.17645 4.41187 5.7814 4.41187 5.2941Z" fill="white"/>
                                    <path d="M9.88229 13.2353C9.29761 13.2353 8.82349 13.6303 8.82349 14.1176C8.82349 14.605 9.29761 15 9.88229 15H13.0588C13.6435 15 14.1176 14.605 14.1176 14.1176C14.1176 13.6303 13.6435 13.2353 13.0588 13.2353H9.88229Z" fill="white"/>
                                </svg>


                            </button>


                        </aside>
                        <!-- end aside -->
                    </div>

                    <template v-if="!loaded">
                        <div class="col-md-12 col-lg-9">
                            <div class="donors__item donors__item--empty d-flex">
                                <div class="LoaderBalls">
                                    <div class="LoaderBalls__item"></div>
                                    <div class="LoaderBalls__item"></div>
                                    <div class="LoaderBalls__item"></div>
                                </div>
                            </div>
                        </div>
                    </template>
                    <template v-else>
                        <div class="col-md-12 col-lg-9" v-if="donorsList.length && loaded">
                            <div class="donors__item" v-for="(donor, idx) in donorsList" :key="idx">
                                <card-horisontal :user="user" :pets="userPets" :donor="donor" :weight="donor.weight" :index="idx"/>
                            </div>

                            <div class="row" v-if="pageCount > 1">
                                <div class="col-md-12">
                                    <div class="pagination-area pull-right">
                                        <nav class="navigation pagination" role="navigation">
                                            <div class="nav-links">
                                                <paginate
                                                    v-model="page"
                                                    :page-count="pageCount"
                                                    :click-handler="paginateClickCallback"
                                                    :prev-text="''"
                                                    :next-text="''"
                                                    :container-class="'className'"
                                                    :page-class="'page-numbers'"
                                                    :page-link-class="''"
                                                    :active-class="'current'"
                                                    :prev-class="'prev page-numbers'"
                                                    :prev-link-class="'lnr lnr-arrow-left'"
                                                    :next-class="'next page-numbers'"
                                                    :next-link-class="'lnr lnr-arrow-right'"
                                                >
                                                </paginate>
                                            </div>
                                        </nav>
                                    </div>
                                </div>
                            </div>

                        </div>
                        <div class="col-md-12 col-lg-9" v-else>
                            <div class="donors__item donors__item--empty d-flex">
                                {{$store.getters.t('donors_list_empty')}}
                            </div>
                        </div>
                    </template>


                </div>
            </div>
        </div>

    </div>
</template>

<style lang="scss">
.LoaderBalls {
    margin: 0 auto;
    width: 90px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    &__item {
        // .LoaderBalls__wrapper__item
        $anim-drt: 0.3s;
        $anim-ease: cubic-bezier(.6,.05,.15,.95);
        width: 20px;
        height: 20px;
        border-radius: 50%;
        background: #2E76E4;

        &:nth-child(1) {
            animation: bouncing $anim-drt alternate infinite $anim-ease;
        }

        &:nth-child(2) {
            animation: bouncing $anim-drt $anim-drt/4 alternate infinite $anim-ease backwards;
        }

        &:nth-child(3) {
            animation: bouncing $anim-drt $anim-drt/2 alternate infinite $anim-ease backwards;
        }
    }
}


@keyframes bouncing {

    0% {
        transform: translate3d(0, 10px, 0) scale(1.2, 0.85);
    }

    100% {
        transform: translate3d(0, -20px, 0) scale(0.9, 1.1);
    }
}


    .donors{

        &__grid{
            padding: 24px 0;
           background: #F0F1F5;
        }

        &__item{
            width: 100%;
            &--empty{
                text-align: center;
                justify-content: center;
                align-items: center;

                font-size: 22px;
                line-height: 26px;

                padding: 24px 40px 26px 30px;
                background: #fff;
                border-radius: 5px;
                box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.1);
                min-height: 200px;

            }
        }

        .search-result {
            position: absolute;
            background-color: white;
            padding: 10px;
            box-shadow: 0 0 5px 0 #ccc;
            width: 100%;
            z-index: 1;

            .city-item {
                cursor: pointer;
                padding: 5px 0;
            }

            .city-item:hover {
                color: #0674ec;
            }
        }




    }

    @media screen and(max-width: 768px){

        .product--sidebar .sidebar-card .card-title .lnr{
            right: -10px;
        }
    }
</style>

<script>
    import KnowledgeNav from "../KnowledgeBase/KnowledgeNav";
    import CardHorisontal from "./CardHorisontal";

    import {paginationScrollTo} from '../helpers/helpers'

    export default {

        components: {
            KnowledgeNav,
            CardHorisontal
        },
        name: "Donors",

        data: () => ({
            appRoutes: null,
            pageCount: 0,
            page: 1,
            donorsList: [],
            weightCategories:{},
            petsCategories: [],
            selectedCategories:[],
            selectedWeight: null,
            citySearch: null,
            citySelected: null,
            selectedCityId: null,
            cities: [],
            loaded: true,
            userPets: []
        }),

        created() {
            this.appRoutes = window.appRoutes;
        },

        mounted() {
            this.loadDataForType()
            this.getPetsCategories()
            this.getUserPets()
            this.getDonorsList()

        },

        props: ['donors'],

        watch: {
            selectedCategories(){
                this.getDonorsList(true);
            },
            donorsList(){
                this.loaded = false;
                setTimeout(()=>{
                    this.loaded = true
                }, 1000)
            },

            selectedWeight(){
                this.getDonorsList(true)
            },

            citySearch(value) {
                if (!value) {
                    this.citySelected = null;
                    this.cities = [];
                    this.selectedCityId = null;
                    return false;
                }

                if (value !== this.citySelected) {
                    this.searchCities();
                }
            },

            selectedCityId() {
                this.getDonorsList(true);
            },

        },

        computed:{
            user(){
                return this.$store.getters.getUserData
            }
        },

        methods: {
            change(key, event){
                let checked = event.target.checked
                if(!checked) return this.selectedWeight = null

                return this.selectedWeight = key
            },


            getUserPets(){

                if (!this.user) return

                let url = `/api/user/pets-list`

                axios(url)
                    .then(response => {
                        response = response.data

                        if(response.success){
                            this.userPets = response.data
                        }

                    })
                    .catch()

            },

            paginateClickCallback(pageNum) {
                this.page = pageNum;

                paginationScrollTo('.donors__grid')

                this.getDonorsList();




            },

            getPetsCategories(){
              let url = '/api/pets/categories'

                axios.get(url)
                    .then(response => {
                        response = response.data

                        if(response.success){
                            this.petsCategories = response.data
                        }

                    })
                    .catch(error => {
                        error = error.response.data
                        console.log(error)
                    })
            },

            loadDataForType(type = 'PET_TYPE_VOLUNTEER') {
                let self = this;
                let url = '/api/dictionary/pet';

                axios.get(url, {
                    params: {
                        type: type
                    }
                })
                    .then(response => {
                        response = response.data;
                        if (response.success) {
                            self.weightCategories = response.data.weight;
                        } else {
                            alert(this.$store.getters.t('common_error_reload'));
                        }
                    })
                    .catch((error) => {

                    })
                    .then();
            },

            getDonorsList: function (resetPage) {
                let url = '/donors';
                if (resetPage) {
                    this.page = 1;
                }

                axios.get(url, {
                    params: {
                        page: this.page,
                        is_donor: 1,
                        pet_category_id: this.selectedCategories,
                        city_id: this.selectedCityId,
                        weight: this.selectedWeight,
                        per_page: 5
                    }
                })
                    .then(response => {
                        response = response.data;
                        if (response.success) {
                            this.donorsList = response.data
                            this.page = response.meta.current_page
                            this.pageCount = response.meta.last_page
                        } else {
                            alert(this.$store.getters.t('common_error_reload'));
                        }
                    })
                    .catch((error) => {

                    })
            },
            setCityId(cityId, cityName) {
                this.selectedCityId = cityId;
                this.citySearch = cityName;
                this.citySelected = cityName;
                this.cities = [];
            },

            searchCities() {
                let self = this;
                let url = '/' + self.appRoutes['geo.searchCities'];

                axios.get(url, {
                    params: {
                        searchValue: self.citySearch
                    }
                })
                    .then(response => {
                        response = response.data;
                        if (response.success) {
                            self.cities = response.cities
                        } else {
                            alert(this.$store.getters.t('common_error_reload'));
                        }
                    })
                    .catch((error) => {

                    })
                    .then();
            },

            sidebarFilterToggle(){
                let productFilter = document.querySelector('.product--sidebar');
                let body = document.querySelector('body');
                productFilter.classList.toggle('product-sidebar--open');
                body.classList.toggle('product-sidebar--open');
            },

            filterToggle(e){
                if(window.matchMedia("min-width: 992px").matches) return

                let filterWrapper = document.querySelector('.product--sidebar-wrapper');
                let filterBtn = document.getElementById('sidebar-toggle');

                if(!filterWrapper.contains(e.target) && !filterBtn.contains(e.target)){
                    let productFilter = document.querySelector('.product--sidebar');
                    let body = document.querySelector('body');

                    productFilter.classList.remove('product-sidebar--open');
                    body.classList.remove('product-sidebar--open');
                    return;

                }

            }

        },

    }
</script>
